import React, { useState, useEffect, useRef } from "react";
import { graphql } from "gatsby";
import { Layout, Seo } from "../../components";
import { ProjectGrid, ProjectGallery } from "../../components/Project";
import { motion, useAnimation } from "framer-motion";

const Project = ({ data }) => {
  const [scrollPos, setScrollPos] = useState(0);
  const [showSecondSection, setShowSecondSection] = useState(false);
  const controls = useAnimation();
  const containerRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      const position = window.scrollY;
      setScrollPos(position);
      controls.start({
        height: `${Math.max(0, 100 - position / 10)}%`,
        filter: `blur(${Math.min(position / 50, 10)}px)`,
      });
    };

    const initialScroll = () => {
      handleScroll();
    };

    // Trigger initial scroll event after component mounts
    initialScroll();

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [controls]);

  useEffect(() => {
    // Show the second section after a short delay to prevent immediate jumping
    const timer = setTimeout(() => {
      setShowSecondSection(true);
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  return (
    <Layout>
      <motion.section
        ref={containerRef}
        id={data.strapiProject.id}
        className="fixed top-0 overflow-hidden w-full h-full flex"
        animate={controls}
      >
        <div className="relative flex w-full flex-col h-full overflow-hidden">
          <ProjectGallery project={data} />
        </div>
      </motion.section>

      {showSecondSection && (
        <section className="relative mt-[100vh] bg-gradient-to-br from-sky-50 to-zinc-50 py-8 lg:py-[2vw] border-t">
          <div className="px-4 lg:px-[2vw]">
            <ProjectGrid projects={data} />
          </div>
        </section>
      )}
    </Layout>
  );
};

export default Project;

export const Head = ({ data }) => <Seo title={data.strapiProject.title} />;

export const query = graphql`
  query SingleProjectQuery($slug: String) {
    strapiProject(slug: { eq: $slug }) {
      id
      slug
      title
      content
      gallery {
        alternativeText
        localFile {
          childImageSharp {
            gatsbyImageData(
              placeholder: DOMINANT_COLOR
              formats: [WEBP]
              layout: CONSTRAINED
            )
          }
          url
        }
      }
      video
    }
    featuredProjects: allStrapiProject(
      filter: { sticky: { eq: true }, slug: { ne: $slug } }
    ) {
      edges {
        node {
          ...ProjectCard
        }
      }
    }
    restOfProjects: allStrapiProject(
      filter: { sticky: { ne: true }, slug: { ne: $slug } }
    ) {
      edges {
        node {
          ...ProjectCard
        }
      }
    }
  }
`;
